<div class="p-grid">
	<div class="p-col-12 p-md-3 d-flex flex-column">
		<div class="d-flex">
			<div class="h4 ms-1 mt-2 mb-1">General Settings</div>
		</div>
		<p-divider></p-divider>
		<div class="d-flex w-100 mt-2">
			Active
			<div class="ms-auto">
				<p-inputSwitch (onChange)="changesToSaveChange.emit(true)" [(ngModel)]="orderType.active"></p-inputSwitch>
			</div>
		</div>

		<div>Display Name</div>
		<div class="mb-3">
			<input
				(change)="changesToSaveChange.emit(true)"
				pInputText
				class="w-100"
				type="text"
				[(ngModel)]="orderType.displayName"
				placeholder="Display Name"
			/>
		</div>
		<div>POS Name</div>
		<div class="mb-3">
			<input (change)="changesToSaveChange.emit(true)" pInputText class="w-100" type="text" [(ngModel)]="orderType.posName" />
		</div>
		<div class="d-flex w-100 mt-2">
			Enable @table
			<div class="ms-auto">
				<p-inputSwitch
					[(ngModel)]="orderType.atTable"
					(onChange)="changesToSaveChange.emit(true)"
					pTooltip="Focus @table allows you to start a check, preauth a credit card and automatically have the check close out at a later time."
				>
				</p-inputSwitch>
			</div>
		</div>
		<div class="d-flex w-100 mt-2">
			Enable Delivery
			<div class="ms-auto">
				<p-inputSwitch (onChange)="changesToSaveChange.emit(true)" (onChange)="verifySavedOt()" [(ngModel)]="orderType.promptAddress"></p-inputSwitch>
			</div>
		</div>

		<div class="d-flex w-100 mt-2">
			Enable FocusKiosk
			<div class="ms-auto">
				<p-inputSwitch (onChange)="changesToSaveChange.emit(true)" [(ngModel)]="orderType.kiosk"></p-inputSwitch>
			</div>
		</div>
		<div class="d-flex w-100 mt-2">
			Enable Future Orders
			<div class="ms-auto">
				<p-inputSwitch
					(onChange)="changesToSaveChange.emit(true)"
					[(ngModel)]="orderType.futureOrders"
					[disabled]="venueSvc.ooVenue.futureOrderMode === 0"
				>
				</p-inputSwitch>
			</div>
		</div>
	</div>
	<div class="p-col-12 p-md-3 d-flex flex-column">
		<div class="d-flex">
			<div class="h4 ms-1 mt-2 mb-1">Payment Options</div>
		</div>
		<p-divider></p-divider>
		<div class="d-flex w-100 mt-2">
			Pay with Credit Card
			<div class="ms-auto">
				<p-inputSwitch (onChange)="changesToSaveChange.emit(true)" [(ngModel)]="orderType.payCreditCard"></p-inputSwitch>
			</div>
		</div>

		<div class="d-flex w-100 mt-2">
			Pay at Store
			<div class="ms-auto">
				<p-inputSwitch (onChange)="changesToSaveChange.emit(true)" [(ngModel)]="orderType.payAtStore"></p-inputSwitch>
			</div>
		</div>

		<div class="d-flex w-100 mt-2">
			Pay with Gift Card
			<div class="ms-auto">
				<p-inputSwitch (onChange)="changesToSaveChange.emit(true)" [(ngModel)]="orderType.payGift"></p-inputSwitch>
			</div>
		</div>
		<div class="d-flex w-100 mt-2">
			Allow tips
			<div class="ms-auto">
				<p-inputSwitch (change)="changesToSaveChange.emit(true)" [(ngModel)]="orderType.tipped"></p-inputSwitch>
			</div>
		</div>

		<div class="d-flex w-100 mt-2">
			Require CC backup for Gift Cards
			<fa-icon
				[icon]="['far', 'question-circle']"
				size="lg"
				class="ms-1"
				pTooltip="If enabled, guests will be required to provide a credit card to 'back up' their gift card transactions. The CC will only be charged if the gift card has insufficent funds at the time of final processing."
			>
			</fa-icon>
			<div class="ms-auto">
				<p-inputSwitch
					(onChange)="changesToSaveChange.emit(true)"
					[(ngModel)]="orderType.payGiftRequireCC"
					[disabled]="!orderType.payGift || !orderType.payCreditCard"
				></p-inputSwitch>
			</div>
		</div>
	</div>
	<div class="p-col-12 p-md-3 d-flex flex-column">
		<div class="d-flex">
			<div class="h4 ms-1 mt-2 mb-1">Order Settings</div>
		</div>
		<p-divider></p-divider>
		<div class="d-flex w-100 mt-2">
			Use Link Table ID
			<fa-icon
				[icon]="['far', 'question-circle']"
				size="lg"
				class="ms-1"
				pTooltip="If @table is DISABLED: if this order type is accessed from a FocusOnline Link, the table ID embedded in the Link Key will be used as the table number/name for the transaction. This MAY result in duplicate table numbers/name at the store-level."
			>
			</fa-icon>
			<div class="ms-auto">
				<p-inputSwitch (onChange)="changesToSaveChange.emit(true)" [(ngModel)]="orderType.useLinkKeyTable" [disabled]="orderType.atTable">
				</p-inputSwitch>
			</div>
		</div>

		<div class="d-flex w-100 mt-2">
			Require Email Address
			<fa-icon
				[icon]="['far', 'question-circle']"
				size="lg"
				class="ms-1"
				pTooltip="Guests will required to enter an email address when placing an order. Turning this OFF will result in guests NOT receiving receipts, order
				notification and loss of customer data."
			></fa-icon>
			<div class="ms-auto">
				<p-inputSwitch (onChange)="changesToSaveChange.emit(true)" [(ngModel)]="orderType.requireEmail"></p-inputSwitch>
			</div>
		</div>

		<div class="d-flex w-100 mt-2">
			Admin Order Email
			<div class="ms-auto">
				<p-inputSwitch (onChange)="changesToSaveChange.emit(true)" [(ngModel)]="orderType.ccAdminEmailOnOrder"> </p-inputSwitch>
			</div>
		</div>
		<div class="d-flex w-100 mt-2">
			Store Customer Data
			<div class="ms-auto">
				<p-inputSwitch (onChange)="changesToSaveChange.emit(true)" [(ngModel)]="orderType.storeCustomerData"> </p-inputSwitch>
			</div>
		</div>
	</div>
	<div class="p-col-12 p-md-3 d-flex flex-column">
		<div class="d-flex">
			<div class="h4 ms-1 mt-2 mb-1">&nbsp;</div>
		</div>
		<p-divider></p-divider>
		<div>Instructions</div>
		<div class="mb-3">
			<textarea
				(change)="changesToSaveChange.emit(true)"
				pInputTextarea
				style="height: 100px; width: 100%"
				[(ngModel)]="orderType.instructions"
			></textarea>
		</div>
		<div class="d-flex w-100 mt-2">
			Include guest name as item
			<fa-icon
				[icon]="['far', 'question-circle']"
				size="lg"
				class="ms-1"
				pTooltip="If enabled, the guests name will be included with each order sent to the printers/FocusKitchen for an order."
			>
			</fa-icon>
			<div class="ms-auto">
				<p-inputSwitch [(ngModel)]="orderType.includeGuestNameOnOrder" (onChange)="changesToSaveChange.emit(true)"> </p-inputSwitch>
			</div>
		</div>
		<div class="d-flex w-100 mt-2">
			Name format
			<fa-icon [icon]="['far', 'question-circle']" class="ms-1" size="lg" pTooltip="What format will the guest's name be printed/display in."> </fa-icon>
			<div class="ms-auto">
				<p-dropdown
					[options]="app.references.includeNameFormat"
					(onChange)="changesToSaveChange.emit(true)"
					optionLabel="label"
					optionValue="value"
					name="includeNameFormat"
					[(ngModel)]="orderType.includeNameFormat"
					[style]="{ width: '100%' }"
					appendTo="body"
				></p-dropdown>
			</div>
		</div>
		<div class="d-flex w-100 mt-2">
			Name Prefix
			<fa-icon
				[icon]="['far', 'question-circle']"
				class="ms-1"
				size="lg"
				pTooltip="The prefix will be printed/displayed before the guests name on a check."
			>
			</fa-icon>
			<div class="ms-auto">
				<p-dropdown
					#includeNameFormat
					[options]="app.references.includeNamePrefix"
					optionLabel="label"
					optionValue="value"
					name="includeNameFormat"
					[(ngModel)]="orderType.includeNamePrefix"
					[style]="{ width: '100%' }"
					appendTo="body"
					[autoDisplayFirst]="false"
					[virtualScroll]="true"
					virtualScrollItemSize="30"
					filter="true"
					(filterBy)="app.keys(app.references.includeNamePrefix)"
				></p-dropdown>
			</div>
		</div>

		<div class="d-flex w-100 mt-2">
			<div class="my-auto">Order Minimum</div>

			<div class="ms-auto">
				<p-inputNumber
					styleClass="w-100"
					[(ngModel)]="orderType.minimumOrderAmount"
					inputId="currency-us"
					mode="currency"
					currency="USD"
					locale="en-US"
					(onInput)="changesToSaveChange.emit(true)"
				></p-inputNumber>
			</div>
		</div>

		<div class="d-flex w-100 mt-2">
			<div class="my-auto">Order Maximum</div>

			<div class="ms-auto">
				<p-inputNumber
					styleClass="w-100"
					[(ngModel)]="orderType.maximumOrderAmount"
					inputId="currency-us"
					mode="currency"
					currency="USD"
					locale="en-US"
					(onInput)="changesToSaveChange.emit(true)"
				></p-inputNumber>
			</div>
		</div>

		<div class="d-flex w-100 mt-2">
			<div class="my-auto">Order Lead Time</div>

			<div class="ms-auto">
				<p-inputNumber (onInput)="changesToSaveChange.emit(true)" styleClass="w-100" [(ngModel)]="orderType.orderLeadTime"></p-inputNumber>
			</div>
		</div>
		<div class="mt-4">
			<span class="p-float-label">
				<p-dropdown
					#checkoutReceiptSelect
					[options]="checkoutReceiptOptions"
					optionLabel="label"
					optionValue="value"
					name="checkoutReceiptSelect"
					[(ngModel)]="orderType.checkoutReceiptStyle"
					[style]="{ width: '100%' }"
					appendTo="body"
					[autoDisplayFirst]="false"
					[virtualScroll]="true"
					virtualScrollItemSize="30"
					filter="true"
					(filterBy)="app.keys(checkoutReceiptOptions)"
					(onChange)="changesToSaveChange.emit(true)"
				></p-dropdown>
				<label for="checkoutReceiptSelect">Checkout Receipt Display</label>
			</span>
		</div>
	</div>
</div>
